import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import {
  PageHeader,
  SimpleDataTable,
  Section,
  toSectionsURL,
  makeBreadcrumb,
  GatsbyLink
} from '@budget-monorepo/shared-ui';

import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';
import PlanFilter from '../components/PlanFilter';

const GovLevelTwo = (props) => {
  const { data, location } = props;
  const { content, site } = data;
  const {
    title, budgetSection, summaryTable, govLevelOne, govLevelTwo, parent: { parent }
  } = content;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = parent;
  const path = location.pathname;
  const pathPrefix = process.env.GATSBY_PATH_PREFIX;
  const relPath = path.replace(pathPrefix, '');
  const { pageTitle, breadcrumbprops } = makeBreadcrumb({
    href: '/beneficiary-agency',
    text: 'Plan by Beneficiary Agency',
    sections: [govLevelOne, govLevelTwo]
  });
  const layoutProps = {
    activeIndex: 1,
    pre: () => <PlanFilter path={relPath} />,
    above: () => <PageHeader title={title} category={budgetSection} />,
    pageTitle,
    breadcrumbprops,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime,
    containerClasses: 'main-content main-content--two'
  };
  const { data: sumData, ...tableRest } = summaryTable;
  const tableData = sumData.map((item) => {
    // Suppress plan item with "suppressed" flag
    if (item.suppressed) {
      return 0;
    }
    const href = toSectionsURL({
      href: '/beneficiary-agency/',
      sections: [item.govLevelOne, item.govLevelTwo, item.planItemNumber]
    });
    return Object.assign({}, item, {
      planItemNumber: <GatsbyLink to={href}>{item.planItemNumber}</GatsbyLink>
    });
  });
  const tableProps = { data: tableData, ...tableRest };
  // metadata for the page
  const metaTitle = title;
  const metaDescription = `Capital investment plan for beneficiary state organization - ${title}.`;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        metaType: 'dataset',
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        {summaryTable
          && (
          <Section>
            <React.Fragment>
              <SimpleDataTable title={`${title} ${budgetSection}`} table={tableProps} maxColWidth={200} download={location.pathname} />
            </React.Fragment>
          </Section>
          )
        }
      </Layout>
    </Fragment>
  );
};

GovLevelTwo.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
  location: PropTypes.object
};

export default GovLevelTwo;

export const query = graphql`
  query($slug: String!) {
    site {
      ...SiteMetadata
    }
    content: planGovLevelTwo(fields: { slug: { eq: $slug } }) {
      title
      budgetSection
      govLevelOne
      govLevelTwo
      fields {
        slug
      }
      summaryTable {
        headers {
          name
          type
          align
          value
        }
        data {
          suppressed
          planItemNumber
          planItemName
          govLevelOne
          govLevelTwo
          stateBondCap
          nonBondCap
          operatingFunds
          federalFunds
          globalTrustFund
          otherFunds
          total
        }
        total {
          govLevelTwo
          stateBondCap
          nonBondCap
          operatingFunds
          federalFunds
          globalTrustFund
          otherFunds
          total
        }
      }
      # Get the last modified timestamp for the file powering the plan item pages
      ...PlanGovLevelTwoDataTimeStamp
    }
  }
`;
